import { render, staticRenderFns } from "./ReporteProductividad.vue?vue&type=template&id=6b5995c1"
import script from "./ReporteProductividad.vue?vue&type=script&lang=js"
export * from "./ReporteProductividad.vue?vue&type=script&lang=js"
import style0 from "./ReporteProductividad.vue?vue&type=style&index=0&id=6b5995c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports